export default __webpack_public_path__ + "assets/models/b1a76af00a08888c1e2537d9e6f34df9.glb";